import { Col, Row } from 'reactstrap';
import {
  CourseEnrollmentStates,
  CourseValidationType,
} from '../../types/CourseValidationType';

import Legend from './parts/Legend';
import { getColor as getColorCore } from './utils';

export interface LegendsProps {
  texts: {
    enrolled: string;
    approved: string;
    pending: string;
    failed: string;
    validated: string;
    internalValidation: string;
    proficiencyValidation: string;
    validationValidation: string;
    rap: string;
    externalValidation: string;
  };
  getColor?: (
    state?: CourseEnrollmentStates | CourseValidationType,
  ) => string | undefined;
}

export default function Legends({
  texts,
  getColor = getColorCore,
}: LegendsProps) {
  return (
    <Row className="d-flex">
      <Col xs={6} sm="auto">
        <Legend
          label={texts.enrolled}
          color={getColor(CourseEnrollmentStates.Enrolled)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.approved}
          color={getColor(CourseEnrollmentStates.Approved)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.pending}
          color={getColor(CourseEnrollmentStates.Pending)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.failed}
          color={getColor(CourseEnrollmentStates.Reject)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.internalValidation}
          color={getColor(CourseValidationType.Internal)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend label={texts.rap} color={getColor(CourseValidationType.RAP)} />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.externalValidation}
          color={getColor(CourseValidationType.External)}
        />
      </Col>
    </Row>
  );
}
